import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";
import { EntStorageRegister } from "../../../models/organic/storage";
import { EntStorageFilter } from "../../../models/filters/organic/storageFilter";

export const storageApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getStorageList: builder.query<ResponseDataGet<EntStorageRegister>, EntStorageFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.storage }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getStorageById: builder.query<ResponseDataGet<EntStorageRegister>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.storage }/${ id }`,
		method: "GET",
	  }),
	}),

	deleteStorage: builder.mutation<ResponseDataGet<EntStorageRegister>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.storage }/${ id }`,
		method: "DELETE",
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useDeleteStorageMutation,
  useLazyGetStorageListQuery,
  useGetStorageListQuery
} = storageApi;
